import { Option } from '@code/innovance-react-ui-kit';
import { minimumLengthTest } from 'src/front/common/utils/validationSchemas';
import { MINIMUM_DATE_CONTROL } from 'src/front/constant';
import { PhoneValidations } from 'src/front/pages/applications/loan-application/phone-email-entry/PhoneEmailEntry';
import * as Yup from 'yup';

export const LoanApplicationProductSchema = Yup.object().shape({
  retailOutlet: Yup.object().nullable().required('general_requiredField_errorMessage'),
  loanType: Yup.object().nullable().required('general_requiredField_errorMessage'),
});
export const LoanPhoneEmailSchema = Yup.object().shape(
  {
    emailAddress: Yup.string()
      .nullable()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .matches(
        // eslint-disable-next-line max-len
        // /^(([^<>()[\]\\.,;:\s@"öüışçğ]+(\.[^<>()[\]\\.,;:\s@"öüışçğ]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
        'cardEntry_phoneEmailEntry_invalidEmailFormat_errorMessage'
      ),
    mobilePhoneCountry: Yup.object().nullable().required('general_requiredField_errorMessage'),
    mobilePhoneFieldCode: Yup.string().when(
      '$formValidations',
      (formValidations: PhoneValidations, schema: Yup.StringSchema) =>
        schema
          .required('general_requiredField_errorMessage')
          .test(
            minimumLengthTest(
              formValidations?.mobilePhone?.minFieldCodeLength || 0,
              'general_minCharacter_errorMessage'
            )
          )
    ),
    mobilePhoneTelephoneNo: Yup.string().when(
      '$formValidations',
      (formValidations: PhoneValidations, schema: Yup.StringSchema) =>
        schema
          .required('general_requiredField_errorMessage')
          .test(
            minimumLengthTest(
              formValidations?.mobilePhone?.minTelephoneNoLength || 0,
              'general_minCharacter_errorMessage'
            )
          )
    ),
    actualLivingAddressPhoneCountry: Yup.object()
      .nullable()
      .when('contactPersonMobilePhone1Country', {
        is: null,
        then: Yup.object().required('general_requiredField_errorMessage'),
        otherwise: Yup.object().notRequired(),
      }),
    actualLivingAddressPhoneFieldCode: Yup.string().when(
      ['$formValidations'],
      (formValidations: PhoneValidations, schema: Yup.StringSchema) =>
        schema
          .when('contactPersonMobilePhone1FieldCode', {
            is: '',
            then: Yup.string().required('general_requiredField_errorMessage'),
            otherwise: Yup.string().notRequired(),
          })
          .test(
            'fixed-length',
            'general_minCharacter_errorMessage',
            (val) =>
              val === '' ||
              val.length >= (formValidations?.actualLivingAddressPhone?.minFieldCodeLength || 0)
          )
    ),
    actualLivingAddressPhoneTelephoneNo: Yup.string().when(
      ['$formValidations'],
      (formValidations: PhoneValidations, schema: Yup.StringSchema) =>
        schema
          .when('contactPersonMobilePhone1TelephoneNo', {
            is: '',
            then: Yup.string().required('general_requiredField_errorMessage'),
            otherwise: Yup.string().notRequired(),
          })
          .test(
            'fixed-length',
            'general_minCharacter_errorMessage',
            (val) =>
              val === '' ||
              val.length >= (formValidations?.actualLivingAddressPhone?.minTelephoneNoLength || 0)
          )
    ),
    workPhoneCountry: Yup.object().nullable().required('general_requiredField_errorMessage'),

    workPhoneFieldCode: Yup.string().when(
      ['$formValidations'],
      (formValidations: PhoneValidations, schema: Yup.StringSchema) =>
        schema
          .required('general_requiredField_errorMessage')
          .test(
            minimumLengthTest(
              formValidations?.workPhone?.minFieldCodeLength || 0,
              'general_minCharacter_errorMessage'
            )
          )
    ),
    workPhoneTelephoneNo: Yup.string().when(
      ['$formValidations'],
      (formValidations: PhoneValidations, schema: Yup.StringSchema) =>
        schema
          .required('general_requiredField_errorMessage')
          .test(
            minimumLengthTest(
              formValidations?.workPhone?.minTelephoneNoLength || 0,
              'general_minCharacter_errorMessage'
            )
          )
    ),
    registrationAddressPhoneCountry: Yup.object().nullable(),

    registrationAddressPhoneFieldCode: Yup.string().when(
      ['$formValidations'],
      (formValidations: PhoneValidations, schema: Yup.StringSchema) =>
        schema.test(
          minimumLengthTest(
            formValidations?.registrationAddressPhone?.minFieldCodeLength || 0,
            'general_minCharacter_errorMessage'
          )
        )
    ),
    registrationAddressPhoneTelephoneNo: Yup.string().when(
      ['$formValidations'],
      (formValidations: PhoneValidations, schema: Yup.StringSchema) =>
        schema.test(
          minimumLengthTest(
            formValidations?.registrationAddressPhone?.minTelephoneNoLength || 0,
            'general_minCharacter_errorMessage'
          )
        )
    ),
    contactPersonMobilePhone1Country: Yup.object()
      .nullable()
      .when('actualLivingAddressPhoneCountry', {
        is: null,
        then: Yup.object().required('general_requiredField_errorMessage'),
        otherwise: Yup.object().notRequired(),
      }),

    contactPersonMobilePhone1FieldCode: Yup.string().when(
      ['$formValidations'],
      (formValidations: PhoneValidations, schema: Yup.StringSchema) =>
        schema
          .when('actualLivingAddressPhoneFieldCode', {
            is: '',
            then: Yup.string().required('general_requiredField_errorMessage'),
            otherwise: Yup.string().notRequired(),
          })
          .test(
            minimumLengthTest(
              formValidations?.contactPersonMobilePhone1?.minFieldCodeLength || 0,
              'general_minCharacter_errorMessage'
            )
          )
    ),
    contactPersonMobilePhone1TelephoneNo: Yup.string().when(
      ['$formValidations'],
      (formValidations: PhoneValidations, schema: Yup.StringSchema) =>
        schema
          .test(
            minimumLengthTest(
              formValidations?.contactPersonMobilePhone1?.minTelephoneNoLength || 0,
              'general_minCharacter_errorMessage'
            )
          )
          .when('actualLivingAddressPhoneTelephoneNo', {
            is: '',
            then: Yup.string().required('general_requiredField_errorMessage'),
            otherwise: Yup.string().notRequired(),
          })
    ),
    contactPersonMobilePhone2Country: Yup.object().nullable(),
    contactPersonMobilePhone2FieldCode: Yup.string().when(
      ['$formValidations'],
      (formValidations: PhoneValidations, schema: Yup.StringSchema) =>
        schema.test(
          'fixed-length',
          'general_minCharacter_errorMessage',
          (val) =>
            val === '' ||
            val.length >= (formValidations?.contactPersonMobilePhone2?.minFieldCodeLength || 0)
        )
    ),
    contactPersonMobilePhone2TelephoneNo: Yup.string().when(
      ['$formValidations'],
      (formValidations: PhoneValidations, schema: Yup.StringSchema) =>
        schema.test(
          'fixed-length',
          'general_minCharacter_errorMessage',
          (val) =>
            val === '' ||
            val.length >= (formValidations?.contactPersonMobilePhone2?.minTelephoneNoLength || 0)
        )
    ),
  },
  [
    ['contactPersonMobilePhone1Country', 'actualLivingAddressPhoneCountry'],
    ['contactPersonMobilePhone1FieldCode', 'actualLivingAddressPhoneFieldCode'],
    ['contactPersonMobilePhone1TelephoneNo', 'actualLivingAddressPhoneTelephoneNo'],
  ]
);
export const LoanAddressSchema = Yup.object().shape({
  addressType: Yup.object().nullable().required('general_requiredField_errorMessage'),
  isRegistration: Yup.bool(),
  addressQuery: Yup.string().when(
    ['suggestion', 'manualAddress'],
    (suggestion: Yup.ObjectSchema, manualAddress: Yup.BooleanSchema, schema: Yup.StringSchema) =>
      schema.required('general_requiredField_errorMessage').test(
        'no-address',
        // TODO(ozgunbal): missing localization
        'Select and adress or continue with manual entry',
        () => !!suggestion || manualAddress
      )
  ),
  registrationDate: Yup.date().when(
    ['addressType', '$todayMaxControl'],
    (addressType: Option, todayMaxControl: Date, schema: Yup.DateSchema) =>
      addressType?.value === 'RA'
        ? schema
            .nullable()
            .min(MINIMUM_DATE_CONTROL, 'cardEntry_minimumYear_errorMessage')
            .max(todayMaxControl, 'general_FutureDateCanNotSelected_errorMessage')
            .required('general_requiredField_errorMessage')
        : schema.nullable().notRequired()
  ),
  country: Yup.object().nullable().required('general_requiredField_errorMessage'),
  region: Yup.object().nullable().required('general_requiredField_errorMessage'),
  city: Yup.string().required('general_requiredField_errorMessage'),
  district: Yup.object().nullable().notRequired(),
  streetType: Yup.object().nullable().required('general_requiredField_errorMessage'),
  street: Yup.string().when('addressType', (addressType: Option, schema: Yup.StringSchema) =>
    addressType?.value === 'WA'
      ? schema.required('general_requiredField_errorMessage')
      : schema.notRequired()
  ),
  houseNumber: Yup.string().when('addressType', (addressType: Option, schema: Yup.StringSchema) =>
    addressType?.value === 'WA'
      ? schema.required('general_requiredField_errorMessage')
      : schema.notRequired()
  ),
  housingStructure: Yup.string(),
  flat: Yup.string(),
  zipCode: Yup.string(),
});
export const TaxNumberSchema = Yup.object().shape({
  taxNumber: Yup.string().test(
    'len',
    'loanApp_taxInfo_innControl_errorMessage',
    (value) => value === '' || value.length === 12
  ),
});
